import { render, staticRenderFns } from "./CardPartnerFormSetting.vue?vue&type=template&id=022da02e&scoped=true&"
import script from "./CardPartnerFormSetting.vue?vue&type=script&lang=js&"
export * from "./CardPartnerFormSetting.vue?vue&type=script&lang=js&"
import style0 from "./CardPartnerFormSetting.vue?vue&type=style&index=0&id=022da02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022da02e",
  null
  
)

export default component.exports